<template>
  <div style="display: flex;flex-direction: column;" >
    <video v-if="videoURL" :src="videoURL" alt="avatar" style="max-height:200px;max-width:200px;margin: 10px;"  controls ></video>
    <a-upload
      v-model:file-list="fileList"
      :show-upload-list="false"
      :customRequest="handleUpload"
      :before-upload="beforeUpload"
      accept="video/mp4"
    >
      <a-button style="margin: 10px;">
        <loading-outlined v-if="loadingImage"></loading-outlined>
        <plus-outlined v-else></plus-outlined>
        上传视频
      </a-button>
    </a-upload>
    <div v-if="videoURL" style="display: flex;flex-direction: row; margin-left: 10px;">
      <a-button size="small" danger @click="handleDelete">
        <delete-outlined />删除视频
      </a-button>
    </div>
  </div>
</template>
<script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'
  import {
  LoadingOutlined, PlusOutlined, DeleteOutlined,
} from '@ant-design/icons-vue';

  export default defineComponent({
    props: {
      videoURL: {
        type: String,
        default: '',
      }
    },
    components: {
      LoadingOutlined,
      PlusOutlined,
      DeleteOutlined,
    },
    data(){
      return {
        fileList: [],
        loadingImage: false,
        // imageUrl: '',
      }
    },
    mounted() {
      // this.imageUrl = this.modelValue
    },
    methods: {
      async handleUpload(file) {
        if (!file.file) {
            message.error("请选择文件")
            return
        }
        this.loadingImage = true
        // /api/aliyun/sts
        const sts = await request.post(`/api/aliyun/sts?image_type=upload`, {}, '上传中...')
        if (sts.error) {
          message.error(`存储服务授权失败:` + sts.error.message)
          return
        }
        const client =  new OSS({
            accessKeyId: sts.data.sts_cert.AccessKeyId,
            accessKeySecret: sts.data.sts_cert.AccessKeySecret,
            stsToken: sts.data.sts_cert.SecurityToken,
            bucket: 'xuantupro',
            region: 'oss-cn-shanghai'
        });
        const name = `/${sts.data.bucket_path}/${sts.data.filename}.${file.file.type.split('/')[1]}`
        const result = await client.multipartUpload(name, file.file);
        var url = "http://statica.xuantu.pro" // 待定
        if (result && result.name) {
            url = url + result.name
        }
        // this.imageUrl = url
        this.$emit('update:videoURL', url)
        this.loadingImage = false
      },
      beforeUpload(file) {
        console.log('beforeUpload', file)
        const isAllow = file.type === 'video/mp4';
        const isLtSize = file.size / 1024 / 1025 < 50;
        if (isAllow && !isLtSize) {
          message.error('视频需要小于 50MB');
          return false
        }
        return true;
      },
      handleDelete(){
         this.$emit('update:videoURL', "")
      },
    },
  })
  </script>
  <style lang='scss' scoped>
  
  </style>